module.exports = __webpack_public_path__ + "static/media/tachandrabindu.4905ae3f.ogg";